/**
 * Curva de XP para niveles progresivos.
 * Nivel 1 = 0 XP, Nivel 2 = 100, Nivel 3 = 250, Nivel 4 = 450...
 * Cada nivel requiere más XP que el anterior.
 */
export const XP_FIRST_LEVEL = 100
export const XP_INCREMENT_PER_LEVEL = 50

/** XP total necesario para alcanzar el nivel L (desde 1). Nivel 1 = 0. */
export function xpToReachLevel(level: number): number {
  if (level <= 1) return 0
  return 100 * (level - 1) + 25 * (level - 2) * (level - 1)
}

/** XP necesario para pasar del nivel actual al siguiente. */
export function xpForNextLevel(currentLevel: number): number {
  return 100 + 50 * (currentLevel - 1)
}

/** Nivel actual dado el XP total. */
export function getLevelFromXP(xp: number): number {
  if (xp < 0) return 1
  let level = 1
  while (xp >= xpToReachLevel(level + 1)) {
    level++
    if (level >= 999) break
  }
  return level
}

/** Progreso 0-1 dentro del nivel actual (para barras de progreso). */
export function xpProgressInLevel(xp: number): { progress: number; current: number; needed: number } {
  const level = getLevelFromXP(xp)
  const needed = xpForNextLevel(level)
  const start = xpToReachLevel(level)
  const current = xp - start
  return {
    progress: needed <= 0 ? 1 : Math.min(1, current / needed),
    current,
    needed,
  }
}

/** Calcular XP a dar por partida según score y nivel del juego. */
export function computeXPFromGame(score: number, gameLevel: number, won: boolean): number {
  const base = won ? 25 : 10
  const scoreXP = Math.min(50, Math.floor(score / 20))
  const levelXP = Math.min(30, gameLevel * 3)
  return base + scoreXP + levelXP
}
